(function () {
    'use strict';

    angular
        .module('core.services')
        .service('PreRegistrationService', PreRegistrationService)

    /** @ngInject */
    function PreRegistrationService(HttpService) {
        const PreRegistrationService = {
            getPreRegistration: getPreRegistration,
            registerPerson: registerPerson
        }

        return PreRegistrationService;

        function getPreRegistration(pinCode) {
            return HttpService.get(`/pre-registers/${pinCode}`);
        }

        function registerPerson(personData) {
            return HttpService.post('/people/', personData);
        }
    }
}());